import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import React, { useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import { track } from '../services/analytics'

function AccordianCardSelect ({
  children,
  eventKey,
  value,
  activeValue,
  onAccordianClick
}) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    onAccordianClick(value)
  )

  return (
    <Card.Header as={Card.Header} onClick={decoratedOnClick}>
      <div className='accordion-header'>
        {children}{' '}
        <img
          className='show-mark'
          alt='activeValue'
          src={
            value === activeValue ? '/imgs/green-check.svg' : '/imgs/plus.svg'
          }
        />
      </div>
    </Card.Header>
  )
}

export default function AccordianSelect ({
  input,
  register,
  errors,
  setValue,
  watch,
  ...props
}) {
  const [activeValue, setActiveValue] = useState('')
  const { options } = input
  const watchActiveValue = watch(input.label)

  if (activeValue === '' && watchActiveValue) {
    setActiveValue(watchActiveValue)
  }

  return (
    <Accordion className='right-accordian'>
      <input
        type='hidden'
        name={input.label}
        {...register(input.label, input.errorHandling)}
      />
      {options.map((item, idx) => (
        <Card className='acc-header our-rounded mb-2' key={idx}>
          <AccordianCardSelect
            eventKey={idx}
            value={item.value}
            activeValue={activeValue}
            onAccordianClick={value => {
              setActiveValue(value)
              setValue(input.label, value, {
                shouldValidate: true,
                shouldDirty: true
              })
              track('Selected accordian', {
                inputType: 'AccordianSelect',
                name: input.label,
                value,
                activeValue
              })
            }}
          >
            <div className='acc-title'>{item.title}</div>
          </AccordianCardSelect>
          <Accordion.Collapse eventKey={idx}>
            <Card.Body>
              <div dangerouslySetInnerHTML={{ __html: item.body }} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  )
}
